<template>
  <div class="relative">
    <hero :heading="heading">
      <div class="mt-6">
        <app-button router-link="/">Go Home, Steve</app-button>
      </div>
    </hero>
  </div>
</template>

<script>
import Hero from "../components/Common/Hero";
import AppButton from "../components/Common/Button";

/**
 * @name 404 view
 */
export default {
  components: {
    Hero,
    AppButton
  },
  data: () => ({
    heading: "Ah shit, this page doesn't exist."
  })
};
</script>
